import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { comics } from '@/mocks/comics';
import { comicCoverImages } from '@/mocks/coverImages';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';

export default function CategoryIndex() {
  return (
    <>
      <SEOHead
        title="漫画分类-韩漫漫画,恋爱漫画,奇幻漫画,动作漫画"
        description="韩漫漫画分类浏览页面，涵盖恋爱、奇幻、动作、悬疑、搞笑、剧情、恐怖、日常八大题材，帮您快速找到心仪的韩国漫画。"
        keywords="韩漫分类,恋爱漫画,奇幻漫画,动作漫画,悬疑漫画,搞笑漫画"
        canonicalUrl="/category"
      />
      <SchemaOrg type="WebPage" data={{
        name: '漫画分类 - 韩漫漫画',
        description: '按题材浏览韩国漫画分类',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'http://netkqn.com/' },
            { '@type': 'ListItem', position: 2, name: '漫画分类', item: 'http://netkqn.com/category' },
          ],
        },
      }} />

      <Navbar />
      <main className="pt-20">
        <section className="py-10 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="mx-auto max-w-7xl">
              <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-8 flex-wrap" aria-label="面包屑导航">
                <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
                <i className="ri-arrow-right-s-line text-xs"></i>
                <span className="text-foreground-800 font-medium">漫画分类</span>
              </nav>

              <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
                漫画分类
              </h1>
              <p className="text-foreground-500 text-sm md:text-base mb-10">
                选择你喜欢的题材，发现更多精彩韩国漫画
              </p>

              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                {categories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="group bg-background-100 hover:bg-primary-50 rounded-2xl p-6 transition-all duration-200 hover:scale-[1.02] cursor-pointer"
                  >
                    <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-200 transition-colors">
                      <i className={`${cat.icon} text-xl`}></i>
                    </div>
                    <h3 className="font-heading text-lg font-bold text-foreground-950 mb-1">{cat.name}</h3>
                    <p className="text-foreground-500 text-sm mb-3">{cat.description}</p>
                    <span className="text-primary-500 text-sm font-medium">
                      {cat.count} 部作品 <i className="ri-arrow-right-line text-xs"></i>
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="mx-auto max-w-7xl">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8">
                全部漫画作品
              </h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
                {comics.map((comic) => (
                  <Link
                    key={comic.id}
                    to={`/comic/${comic.slug}`}
                    className="group cursor-pointer"
                  >
                    <div className="relative overflow-hidden rounded-xl bg-background-200 aspect-[3/4] mb-3">
                      <img
                        src={comicCoverImages[comic.slug]}
                        alt={comic.title}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                        loading="lazy"
                        title={comic.title}
                      />
                      <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs">
                        {comic.rating}
                      </div>
                    </div>
                    <h3 className="text-foreground-950 text-sm font-medium truncate group-hover:text-primary-500 transition-colors">
                      {comic.title}
                    </h3>
                    <p className="text-foreground-500 text-xs mt-0.5">{comic.author}</p>
                    <div className="flex flex-wrap gap-1 mt-1">
                      {comic.tags.slice(0, 2).map((tag) => (
                        <span key={tag} className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 text-xs">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
